// autoley_dashboard.jsx — AutoLey license-support admin dashboard layout.
// Owns the active tab and renders the matching manager under the header.
//
// The licenses tab can be opened from the others (the overview's "Open in
// Licenses", an activity row's license), so the filter and the license to
// open live here — the only state two tabs share.

import { useState } from 'react';
import { Toaster } from 'react-hot-toast';
import AutoLeyHeaderBar from '../constant_components/header_bar';
import OverviewManager from './overview_manager';
import LicensesManager from './licenses_manager';
import ActivityManager from './activity_manager';

export default function AutoLeyDashboard() {
  const [activeTab, setActiveTab] = useState('overview');
  const [licenseFilter, setLicenseFilter] = useState('all');
  const [focusLicenseId, setFocusLicenseId] = useState(null);

  const showLicenses = (filter) => {
    setLicenseFilter(filter || 'all');
    setActiveTab('licenses');
  };

  const openLicense = (licenseId) => {
    setFocusLicenseId(licenseId);
    setActiveTab('licenses');
  };

  const changeTab = (tab) => {
    if (tab === 'licenses') setLicenseFilter('all');
    setActiveTab(tab);
  };

  const renderContent = () => {
    switch (activeTab) {
      case 'licenses':
        return (
          <LicensesManager
            initialFilter={licenseFilter}
            focusLicenseId={focusLicenseId}
            onFocusHandled={() => setFocusLicenseId(null)}
          />
        );
      case 'activity':
        return <ActivityManager onOpenLicense={openLicense} />;
      case 'overview':
      default:
        return <OverviewManager onShowLicenses={showLicenses} />;
    }
  };

  return (
    // text-left: App.css centres text app-wide (.App), which tables and forms here don't want.
    <div className="min-h-screen bg-slate-50 text-left">
      <Toaster position="top-right" toastOptions={{ duration: 3500 }} />
      <AutoLeyHeaderBar activeTab={activeTab} onTabChange={changeTab} />
      <main className="fade-in-enter-active">{renderContent()}</main>
    </div>
  );
}
